import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=72da2fdb&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72da2fdb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72da2fdb')) {
      api.createRecord('72da2fdb', component.options)
    } else {
      api.reload('72da2fdb', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=72da2fdb&scoped=true&", function () {
      api.rerender('72da2fdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dQSqeLsbEXzu/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports